import { i18n, Translations } from "@i18n";
import * as yup from "yup";
import { EmailFormValues } from "./types";

export const validationSchema: yup.SchemaOf<EmailFormValues> = yup.object().shape({
  email: yup
    .string()
    .email(i18n.t(Translations.EmailRouteInputError))
    .required(i18n.t(Translations.EmailRouteInputRequired)),
});
